import { Color } from '@tmh-website/shared/colors';
import styled, { css, keyframes } from 'styled-components';

const fadeIn = keyframes`
  0% { opacity: 0};
  100% { opacity: 1};
`;

interface ContainerProps {
  $size: number;
  $absolutePosition: boolean;
  $noMargin: boolean;
}

export const Container = styled.span<ContainerProps>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  animation: ${fadeIn} 0.5s ease;

  ${props =>
    props.$absolutePosition &&
    css`
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    `};

  ${props =>
    props.$noMargin &&
    css`
      margin: 0 !important;
    `};
`;

interface SpinnerProps {
  $spinnerSize: number;
  $borderWidth: number;
  $color: Color;
}

const spinAnimation = keyframes`
  from {transform: rotate(0deg)}
  to {transform: rotate(360deg)}
`;

export const Spinner = styled.span<SpinnerProps>`
  box-sizing: border-box;
  display: inline-block;
  width: ${props => props.$spinnerSize}px;
  height: ${props => props.$spinnerSize}px;
  border: solid ${props => props.$borderWidth}px ${props => props.theme.color[props.$color]};
  border-top-color: transparent;
  border-radius: ${({ theme }) => (theme.isBorderRadiusDisabled ? 0 : '99999px')};
  animation: ${spinAnimation} 0.75s linear infinite;
`;
